import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { Core2Config } from '../../shared/core2Config';
import { MrpProcessInstanceContainerModel } from '../../../../../../models/aggregates/mrp-prodsys';
import { ApiVisa, BasicApiResponseModel } from '../../shared';

@Injectable({
  providedIn: 'root'
})
export class MrpProcessInstanceService extends BaseApiTemplateService<MrpProcessInstanceContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + "mrp/mrp-process-instances"

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + "mrp/mrp-process-instances"
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + "mrp/mrp-process-instances"
    this.httpClient = http;
  }

  public finalAutoCoiling(guid: string, visa: ApiVisa) {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const url = this.apiUrl + "/" + Core2Config.BACKOFFICE_EP_SUFFIX + "/update-inventory-from-process-instance/" + guid;
    return this.httpClient.get<BasicApiResponseModel<MrpProcessInstanceContainerModel>>(
      url, this.getHttpHeader(visa));
  }
}
